import React from 'react';
import {Day} from "../data/CalendarTypes";
import dayjs from "dayjs";

export default function CalenderCard({day, wordsPerDay}: { day: Day, wordsPerDay: number }) {

    return (
        <div className="calendar-day">
            <div className="calendar-day-value">{day.dayOfMonth}</div>
            {day.date.isAfter(dayjs().startOf("day")) ?
                // <div> {/* remaining words */}
                //     {wordsPerDay}
                //     <div className="calendar-count-words u-pb-h text-uppercase"></div>
                // </div>
                " "
                :
                <div>
                    <div className="calendar-count-value">+ {day.wordCount}</div>
                    <div className="calendar-count-words u-pb-h text-uppercase">words</div>
                </div>
            }
        </div>
    )
}